
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function Splash() {
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate('/language');
    }, 3000);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-500 to-purple-600 flex flex-col items-center justify-center relative overflow-hidden">
      {/* Background Animation */}
      <div className="absolute inset-0 opacity-20">
        <div className="absolute top-20 left-10 w-32 h-32 bg-white/10 rounded-full animate-pulse"></div>
        <div className="absolute bottom-32 right-16 w-24 h-24 bg-white/10 rounded-full animate-pulse delay-1000"></div>
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-40 h-40 bg-white/5 rounded-full animate-pulse delay-500"></div>
      </div>

      {/* Logo and App Name */}
      <div className="text-center animate-fade-in">
        <div className="w-32 h-32 mx-auto mb-8 bg-white/20 rounded-full flex items-center justify-center backdrop-blur-sm">
          <i className="ri-flight-takeoff-line text-6xl text-white"></i>
        </div>
        
        <h1 className="text-4xl font-bold text-white mb-4 font-arabic">
          سامي عبدالسلام
        </h1>
        
        <p className="text-white/80 text-lg font-arabic">
          تواصل مع المسافرين على نفس رحلتك
        </p>
      </div>

      {/* Loading Animation */}
      <div className="absolute bottom-20 flex space-x-2">
        <div className="w-3 h-3 bg-white/60 rounded-full animate-bounce"></div>
        <div className="w-3 h-3 bg-white/60 rounded-full animate-bounce delay-100"></div>
        <div className="w-3 h-3 bg-white/60 rounded-full animate-bounce delay-200"></div>
      </div>

      <style jsx>{`
        @keyframes fade-in {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        
        .animate-fade-in {
          animation: fade-in 1.5s ease-out;
        }
        
        .font-arabic {
          font-family: 'Tajawal', 'Noto Sans Arabic', sans-serif;
        }
      `}</style>
    </div>
  );
}
